import { computed } from "vue";
import { useShopPermissions } from "./useShopPermissions";

export const FINANCIALS_PERMISSION = "shop.financials.view";

/**
 * One switch for "may this user see money?" — prices, order amounts, payment
 * amounts, revenue/AOV/LTV statistics, purchase costs.
 *
 * Shops hand panel logins to warehouse and support staff who must work orders
 * without seeing what the business earns. The role checkbox is coarse on
 * purpose: one box, no per-view matrix to misconfigure.
 *
 *   const { canSeeFinancials } = useFinancialVisibility();
 *   <td v-if="canSeeFinancials">{{ formatCurrency(order.total) }}</td>
 *
 * This is presentation only. The API drops the fields server-side
 * (App\Support\FinancialVisibility), so a hidden amount is genuinely absent
 * from the response rather than merely unrendered — don't rely on v-if alone
 * when adding new money to a view.
 *
 * Defaults to false until the permission fetch resolves, so nothing flashes on
 * screen before we know whether it's allowed.
 */
export function useFinancialVisibility(shopUuidOverride = null) {
  const { can } = useShopPermissions(shopUuidOverride);

  const canSeeFinancials = computed(() => can(FINANCIALS_PERMISSION));

  return { canSeeFinancials, FINANCIALS_PERMISSION };
}
